import React, { memo, useCallback } from "react";
import NormalSearch from "./NormalSearch";
import AISearch     from "./AISearch";
import "./SearchBar.css";

function Slash() {
  return (
    <div className="search-slash" aria-hidden="true">
      <svg width="24" height="52" viewBox="0 0 24 52" fill="none">
        <line x1="19" y1="3" x2="5" y2="49"
          stroke="#1a3a8f" strokeWidth="3.5" strokeLinecap="round"/>
      </svg>
    </div>
  );
}

function SearchBarContainer({ onSearch }) {
  const handleSearch = useCallback((q) => onSearch?.(q), [onSearch]);
  return (
    <div className="search-wrap">
      <div className="dual-search-bar">
        <NormalSearch onSearch={handleSearch} />
        <Slash />
        <AISearch />
      </div>
    </div>
  );
}

export default memo(SearchBarContainer);